import { Divider, Stack } from '@mui/material';
import { type ReactElement } from 'react';

import { content, formatTimeRangeForDate } from '../../../../utils';
import { TooltipElement } from '../../HoverCard';
import { type CalendarRaumEvent, type CalendarStandortEvent, isSeminarraumEvent } from '../helperClasses';
import {
  type AbstractCalendarEvent,
  type InternalCalendarEvent,
  isStandortEvent,
} from '../helperClasses/CalendarEvent';

const printGruppenraum = (event: CalendarStandortEvent): string =>
  event.blockungData.gruppenraumNotwendig?.length ? 'Ja' : 'Nein';
const printRaumgroesse = (event: AbstractCalendarEvent): string =>
  event.blockungData.raumgroesse ? `${event.blockungData.raumgroesse}${content.unitsWs.qm}` : '-';

const renderTooltipForStandortEvent = (event: CalendarStandortEvent): ReactElement => (
  <>
    <TooltipElement label="Gruppenraum" value={printGruppenraum(event)} />
    <TooltipElement label="Hotelqualifikation" value="siehe genereller Kommentar" />
    <TooltipElement label="Benötigte Raumgröße" value={printRaumgroesse(event)} />
  </>
);
const renderTooltipForRaumEvent = (event: CalendarRaumEvent): ReactElement => (
  <TooltipElement label="Benötigte Raumgröße" value={printRaumgroesse(event)} />
);

const getExtendedToolkit = (event: AbstractCalendarEvent): ReactElement | null => {
  if (isSeminarraumEvent(event)) {
    return renderTooltipForRaumEvent(event);
  } else if (isStandortEvent(event)) {
    return renderTooltipForStandortEvent(event);
  } else {
    return null;
  }
};

const renderExtendedTooltipForEvent = (event: AbstractCalendarEvent): ReactElement | null => {
  const extendedToolkit = getExtendedToolkit(event);

  return extendedToolkit ? (
    <>
      <Divider />
      {extendedToolkit}
    </>
  ) : null;
};

type VivaEventTooltipProps = {
  readonly event: InternalCalendarEvent;
};

export const VivaEventTooltip: React.FC<VivaEventTooltipProps> = (props: VivaEventTooltipProps): ReactElement => {
  const calendarEvent = props.event;

  return (
    <Stack gap={1} m={1}>
      <TooltipElement label="" value={calendarEvent.blockungData.veranstaltung.titel} />
      <TooltipElement
        label="AKA-Veranstaltung-ID"
        value={calendarEvent.blockungData.veranstaltung.akaVeranstaltungId}
      />
      <TooltipElement label="SAP-ID" value={calendarEvent.blockungData.veranstaltung.veranstaltungSapId ?? '-'} />
      <TooltipElement label="Geschäftsbereich" value={calendarEvent.blockungData.veranstaltung.geschaeftsbereich} />
      <TooltipElement
        label="Ablaufzeiten"
        value={calendarEvent.blockungData.zeitraeume
          .map(({ start, end }) => formatTimeRangeForDate(start, end))
          .join('\n')}
      />
      {renderExtendedTooltipForEvent(calendarEvent)}
    </Stack>
  );
};
